// extracted by mini-css-extract-plugin
export var subtitle = "_9t-2";
export var title = "_9t-0";
export var titleNoWrap = "_9t-1";